export default __webpack_public_path__ + "img/blocked-users-icon-d141c7ceb15981d42adfee52acb4b765.png";